<ng-container>
	<mat-card
		[ngStyle]="_visible()"
		class="panel">
		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button id="mat-clear-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>
		<mat-card-content class="panel-content">
			<div *ngIf="locked" cdkDragHandle></div>
			<div fxLayout="row">

				<ngx-charts-bar-vertical (select)="onSelect($event)" (window:resize)="onResize($event)"
										 [gradient]="true"
										 [legend]="false"
										 [results]="shot"
										 [scheme]="lineChartColorScheme"
										 [showXAxisLabel]="false"
										 [showYAxisLabel]="true"
										 [view]="size"
										 [xAxisLabel]="lineChartXAxisLabel"
										 [xAxis]="true"
										 [yAxisLabel]="lineChartYAxisLabel"
										 [yAxis]="true"
										 fxFlex
										 fxLayoutAlign="center"
										 tooltipDisabled="true">
				</ngx-charts-bar-vertical>

			</div>
			<ng-template #noData>
				<mat-card style="background-color:#cdcdcd;">
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>
</ng-container>
